module.exports = __webpack_public_path__ + "img/HY2701-01.fc9040df.jpg";